import type { TranslationFunctions } from '$i18n/i18n-types';

export enum QueueType {
  Solo = 1,
  Duo = 2,
  Squad = 3,
  Cobalt = 4,
}

export enum QueueTypeWithAll {
  All = 0,
  Solo = 1,
  Duo = 2,
  Squad = 3,
  Cobalt = 4,
}

export function getQueueTypeName(LL: TranslationFunctions, erarQueueType: string) {
  type Key = keyof TranslationFunctions['glossary']['queueTypes'];
  return LL.glossary.queueTypes[QueueType[parseInt(erarQueueType)].toLowerCase() as Key]();
}
